module.exports = __webpack_public_path__ + "static/media/arrow-left.03e027d6.svg";